import React, { useState, useEffect } from 'react';
import { 
Container, 
Typography, 
Button, 
Paper, 
TextField,
Dialog,
DialogTitle,
DialogContent,
DialogActions,
IconButton,
Box,
Chip,
Divider,
useTheme,
Grid,
Slide,
MenuItem,
InputLabel,
FormControl,
Select,
TablePagination,
TableContainer,
Table,
TableHead,
TableRow,
TableCell,
TableBody,
Card,
CardContent,
CircularProgress,
Alert,
Snackbar,
LinearProgress,
Stepper,
Step,
StepLabel,
Accordion,
AccordionSummary,
AccordionDetails,
Tooltip,
Menu
} from '@mui/material';
import { 
Delete, 
PictureAsPdf,
TableChart, 
GetApp,
Add,
Search,
FilterList,
Refresh,
Today,
Edit,
Visibility,
Close,
ExpandMore,
CheckCircle,
Warning,
AttachMoney,
Inventory,
Receipt,
Calculate,
Save,
Print,
Download,
Timeline,
Assessment,
BarChart
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import axios from 'axios';
import useCustomToast from '../../../hooks/useToast';
import {
APIClubDayClossingList,
APIClubDayClossingCounterStock,
APIClubDayClossingTodaySales,
APIClubDayClossingStore,
APIClubDayClossingUpdateStatus,
APIClubDayClossingDelete,
} from '../../../services/APIs';
import { TEXT_CONNECTION_ERROR, TEXT_DATA_LOADED } from '../../../services/Text';
import {formatNumberWithComma,formatNumberWithComma2,getUserDetails,recordsPerPage} from '../../../utils/helpers';
import { exportToExcel,exportToPDF,exportDetailedPDF,exportToCSV} from '../../../services/club/DayClossingService';

import { fetchBranchs, fetchCounters } from '../../../utils/namesListUtils';
import { getUserRole, PERMISSIONS, ROLE_PERMISSIONS } from '../../../utils/Permission';

const DayClossing = () => {
const theme = useTheme();
const [loading, setLoading] = useState(false);
const [clossingLoading, setClossingLoading] = useState(false);
const [exportAnchorEl, setExportAnchorEl] = useState(null);
const [error, setError] = useState(null);
const showToast = useCustomToast();

const [activeStep, setActiveStep] = useState(0);
const [selectedCounter, setSelectedCounter] = useState('');
const [selectedBranch, setSelectedBranch] = useState('');
const [counterStock, setCounterStock] = useState([]);
const [todaySales, setTodaySales] = useState(null);
const [actualCash, setActualCash] = useState('');
const [clossingNotes, setClossingNotes] = useState('');

const [pageState, setPageState] = useState({
    pageData: [],
    counterNamesData: [],
    branchNamesFilterData: [],
    summaryStats: null
});

const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
const [selectedRecord, setSelectedRecord] = useState(null);
const [searchTerm, setSearchTerm] = useState('');

const [filters, setFilters] = useState({
    counter_id: '',
    branch_id: '',
    dateFrom: new Date().toISOString().split('T')[0],
    dateTo: new Date().toISOString().split('T')[0],
    status: ''
});

const [openAdd, setOpenAdd] = useState(false);
const [openView, setOpenView] = useState(false);
const [openDelete, setOpenDelete] = useState(false);
const [openStatus, setOpenStatus] = useState(false);
const [statusDialog, setStatusDialog] = useState(false);

const [userRole, setUserRole] = useState('');

useEffect(() => {
    const role = getUserRole();
    setUserRole(role);
    fetchData();
    fetchBranchNames();
    fetchCounterNames();
}, []);

const hasPermission = (permission) => {
    return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
};

const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    try {
    let branchIdToUse = '';
    if (!hasPermission(PERMISSIONS.BRANCHES)) {
        branchIdToUse = getUserDetails("branchId");
    }
    
    const params = {};
    if (branchIdToUse) {
        params.branch_id = branchIdToUse;
    }
    
    const response = await axios.get(APIClubDayClossingList, { params });
    
    setPageState(prev => ({
        ...prev,
        pageData: response.data.data || []
    }));
    
    showToast("Success", TEXT_DATA_LOADED, "success");
    } catch (error) {
    let errorMessage = "Failed to load data";
    if (error.response) {
        errorMessage = error.response.data.message || error.message;
    } else if (error.code === "ERR_NETWORK") {
        errorMessage = TEXT_CONNECTION_ERROR;
    }
    setError(errorMessage);
    showToast("Error", errorMessage, "error");
    } finally {
    setLoading(false);
    }
};

const fetchBranchNames = async () => {
    try {
    const data = await fetchBranchs();
    setPageState(prev => ({
        ...prev,
        branchNamesFilterData: data || []
    }));
    } catch (error) {
    showToast("Error", error.message, "error");
    }
};

const fetchCounterNames = async () => {
    try {
    const data = await fetchCounters();
    setPageState(prev => ({
        ...prev,
        counterNamesData: data || []
    }));
    } catch (error) {
    showToast("Error", error.message, "error");
    }
};

const handleExportClick = (event) => {
  setExportAnchorEl(event.currentTarget);
};

const handleExportClose = () => {
  setExportAnchorEl(null);
};

const handleExportExcel = async () => {
  try {
    handleExportClose();
    await exportToExcel(pageState.pageData, {
      counterNamesData: pageState.counterNamesData,
      branchNamesFilterData: pageState.branchNamesFilterData
    });
    showToast("Success", "Excel file downloaded successfully", "success");
  } catch (error) {
    console.error('Excel export error:', error);
    showToast("Error", error.message, "error");
  }
};

const handleExportPDF = async () => {
  try {
    handleExportClose();
    await exportToPDF(pageState.pageData, {
      counterNamesData: pageState.counterNamesData,
      branchNamesFilterData: pageState.branchNamesFilterData
    });
    showToast("Success", "PDF file downloaded successfully", "success");
  } catch (error) {
    console.error('PDF export error:', error);
    showToast("Error", error.message, "error");
  }
};

const handleExportDetailedPDF = async () => {
  try {
    handleExportClose();
    await exportDetailedPDF(pageState.pageData, {
      counterNamesData: pageState.counterNamesData,
      branchNamesFilterData: pageState.branchNamesFilterData
    });
    showToast("Success", "Detailed PDF downloaded successfully", "success");
  } catch (error) {
    console.error('Detailed PDF export error:', error);
    showToast("Error", error.message, "error");
  }
};

const handleExportCSV = async () => {
  try {
    handleExportClose();
    await exportToCSV(pageState.pageData, {
      counterNamesData: pageState.counterNamesData,
      branchNamesFilterData: pageState.branchNamesFilterData
    });
    showToast("Success", "CSV file downloaded successfully", "success");
  } catch (error) {
    console.error('CSV export error:', error);
    showToast("Error", error.message, "error");
  }
};
const handleCounterSelect = async () => {
    if (!selectedCounter) {
    showToast("Warning", "Please select both counter and branch", "warning");
    return;
    }
    
    setClossingLoading(true);
    try {
    // Get counter stock
    const stockResponse = await axios.get(APIClubDayClossingCounterStock, {
        params: {
        counter_id: selectedCounter,
        branch_id: getUserDetails("branchId")
        }
    });
    
    if (stockResponse.data.status === 'error' && stockResponse.data.data?.existing_clossing_id) {
        showToast("Warning", "Day clossing already exists for today. Would you like to view it?", "warning");
        setActiveStep(0);
        return;
    }
    setCounterStock(stockResponse.data.data || []);
    
    // Get today's sales
    const salesResponse = await axios.get(APIClubDayClossingTodaySales, {
        params: {
        counter_id: selectedCounter,
        branch_id: getUserDetails("branchId")
        }
    });
    console.log("stockResponse.data.data"+JSON.stringify(stockResponse.data.data))
    setTodaySales(salesResponse.data.data || null);

    // Merge stock with sales data
    const mergedStock = stockResponse.data.data.map(stock => {
        const salesItem = salesResponse.data.data?.sales_by_item?.find(item => item.stock_id === stock.id);
        return {
        ...stock,
        opening_quantity: stock.balance + (salesItem?.sold_quantity || 0),
        sold_quantity: salesItem?.sold_quantity || 0,
        clossing_quantity: stock.balance,
        opening_value: (stock.balance + (salesItem?.sold_quantity || 0)) * stock.selling,
        sales_value: (salesItem?.sales_value || 0),
        clossing_value: stock.balance * stock.selling
        };
    });
    
    setCounterStock(mergedStock);
    setActiveStep(1);
    
    } catch (error) {
    showToast("Error", error.response?.data?.message || error.message, "error");
    } finally {
    setClossingLoading(false);
    }
};

const handleSaveClossing = async () => {
    if (!actualCash || actualCash <= 0) {
    showToast("Warning", "Please enter actual cash amount", "warning");
    return;
    }
    
    const items = counterStock.map(stock => ({
    stock_id: stock.id,
    opening_quantity: stock.opening_quantity,
    sold_quantity: stock.sold_quantity,
    clossing_quantity: stock.clossing_quantity
    }));
    
    const clossingData = {
    counter_id: selectedCounter,
    branch_id: getUserDetails("branchId"),
    clossing_date: new Date().toISOString().split('T')[0],
    actual_cash: parseFloat(actualCash),
    notes: clossingNotes,
    items: items,
    user_id: getUserDetails("Id")
    };
    
    try {
    setClossingLoading(true);
    const response = await axios.post(APIClubDayClossingStore, clossingData);
    
    if (response.data.status === 'success') {
        showToast("Success", "Day clossing saved successfully", "success");
        setOpenAdd(false);
        resetClossingForm();
        fetchData();
    }
    } catch (error) {
    showToast("Error", error.response?.data?.message || error.message, "error");
    } finally {
    setClossingLoading(false);
    }
};

const resetClossingForm = () => {
    setActiveStep(0);
    setSelectedCounter('');
    setSelectedBranch('');
    setCounterStock([]);
    setTodaySales(null);
    setActualCash('');
    setClossingNotes('');
};

const calculateTotals = () => {
    if (!counterStock.length) return { opening: 0, sales: 0, clossing: 0, expected: 0 };
    return counterStock.reduce((totals, stock) => ({
    opening: totals.opening + (stock.opening_quantity * stock.selling),
    sales: totals.sales + (stock.sold_quantity * stock.selling),
    clossing: totals.clossing + (stock.clossing_quantity * stock.selling),
    expected: totals.expected + (stock.sold_quantity * stock.selling)
    }), { opening: 0, sales: 0, clossing: 0, expected: 0 });
};

const totals = calculateTotals();
const variance = actualCash ? parseFloat(actualCash) - totals.expected : 0;

const handleOpenAdd = () => {
    resetClossingForm();
    setOpenAdd(true);
};

const handleCloseAdd = () => {
    setOpenAdd(false);
    resetClossingForm();
};

const handleOpenView = (record) => {
    setSelectedRecord(record);
    setOpenView(true);
};

const handleCloseView = () => setOpenView(false);

const handleOpenStatus = (record) => {
    setSelectedRecord(record);
    setStatusDialog(true);
};

const handleCloseStatus = () => setStatusDialog(false);

const handleOpenDelete = (record) => {
    setSelectedRecord(record);
    setOpenDelete(true);
};

const handleCloseDelete = () => setOpenDelete(false);

const handleUpdateStatus = async (status) => {
    try {
    const response = await axios.post(APIClubDayClossingUpdateStatus, {
        clossing_id: selectedRecord.id,
        status: status,
        notes: clossingNotes
    });
    
    if (response.data.status === 'success') {
        showToast("Success", "Status updated successfully", "success");
        handleCloseStatus();
        fetchData();
    }
    } catch (error) {
    showToast("Error", error.response?.data?.message || error.message, "error");
    }
};

const handleDelete = async () => {
    try {
    const response = await axios.delete(APIClubDayClossingDelete, {
        data: { clossing_id: selectedRecord.id }
    });
    
    if (response.data.status === 'success') {
        showToast("Success", "Day clossing deleted successfully", "success");
        handleCloseDelete();
        fetchData();
    }
    } catch (error) {
    showToast("Error", error.response?.data?.message || error.message, "error");
    }
};

const steps = ['Select Counter', 'Review Stock & Sales', 'Confirm & Save'];

const getStatusColor = (status) => {
    switch(status) {
    case 'draft': return 'warning';
    case 'submitted': return 'info';
    case 'approved': return 'success';
    case 'rejected': return 'error';
    default: return 'default';
    }
};

if (loading) return <div>Loading...</div>;
if (error) return <div>Error: {error}</div>;

return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
    <Typography sx={{
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        mb: 3
    }}>
        Day Clossing Management
    </Typography>
    
    {/* Summary Cards */}
    <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Receipt sx={{ fontSize: 30, mr: 2, color: 'primary.main' }} />
                <Box>
                <Typography variant="body2" color="text.secondary">
                    Total Clossings
                </Typography>
                <Typography $ sx={{ fontWeight: 'bold' }}>
                    {formatNumberWithComma2(pageState.pageData.length)}
                </Typography>
                </Box>
            </Box>
            </CardContent>
        </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <AttachMoney sx={{ fontSize: 30, mr: 2, color: 'success.main' }} />
                <Box>
                <Typography variant="body2" color="text.secondary">
                    Total Sales
                </Typography>
                <Typography $ sx={{ fontWeight: 'bold' }}>
                    {formatNumberWithComma(pageState.pageData.reduce((sum, item) => sum + parseFloat(item.sales_total), 0))}
                </Typography>
                </Box>
            </Box>
            </CardContent>
        </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CheckCircle sx={{ fontSize: 30, mr: 2, color: 'info.main' }} />
                <Box>
                <Typography variant="body2" color="text.secondary">
                    Approved
                </Typography>
                <Typography $ sx={{ fontWeight: 'bold' }}>
                    {formatNumberWithComma(pageState.pageData.filter(item => item.status === 'approved').length)}
                </Typography>
                </Box>
            </Box>
            </CardContent>
        </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Calculate sx={{ fontSize: 30, mr: 2, color: 'warning.main' }} />
                <Box>
                <Typography variant="body2" color="text.secondary">
                    Total Variance
                </Typography>
                <Typography $ sx={{ fontWeight: 'bold' }}>
                    {formatNumberWithComma(pageState.pageData.reduce((sum, item) => sum + parseFloat(item.variance), 0))}
                </Typography>
                </Box>
            </Box>
            </CardContent>
        </Card>
        </Grid>
    </Grid>
    
    {/* Controls */}
    <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
            <Button
            variant="contained"
            color="warning"
            startIcon={<Add />}
            onClick={handleOpenAdd}
            sx={{ textTransform: 'none', borderRadius: '8px' }}
            >
            New Day Clossing
            </Button>

            {hasPermission(PERMISSIONS.EXPORT)&&(<>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<GetApp />}
                    onClick={handleExportClick}
                    sx={{ textTransform: 'none', borderRadius: '8px' }}
                >
                    Export Data
                </Button>
            </>)}

            <Button
            variant="contained"
            color="info"
            startIcon={<Refresh />}
            onClick={fetchData}
            sx={{ textTransform: 'none', borderRadius: '8px' }}
            >
            Refresh
            </Button>
        </Box>

        <Paper sx={{
            width: { xs: '100%', sm: '300px' },
            p: '2px 8px',
            display: 'flex',
            alignItems: 'center',
            marginLeft: { xs: 0, sm: 'auto' },
            borderRadius: '8px',
            background: theme.palette.primary.light
        }}>
            <TextField
            fullWidth
            variant="outlined"
            placeholder="Search clossings..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                sx: {
                '& fieldset': { border: 'none' },
                fontSize: '0.875rem',
                color: 'white',
                '& input': { color: 'white' }
                }
            }}
            size="small"
            />
        </Paper>
        </Box>
    </Paper>
    
    {/* Day Clossing Table */}
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
    >
        <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <TableContainer>
            <Table>
            <TableHead>
                <TableRow sx={{
                backgroundColor: theme.palette.primary.main,
                '& th': { color: 'white', fontWeight: 'bold' }
                }}>
                <TableCell>Clossing #</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Counter</TableCell>
                <TableCell>Sales Total</TableCell>
                <TableCell>Expected Cash</TableCell>
                <TableCell>Actual Cash</TableCell>
                <TableCell>Variance</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {pageState.pageData
                .filter(item => 
                    item.clossing_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    (item.counter?.name || '').toLowerCase().includes(searchTerm.toLowerCase())
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((clossing, index) => (
                    <TableRow
                    key={index}
                    hover
                    sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } }}
                    >
                    <TableCell sx={{ fontWeight: 'medium' }}>
                        {clossing.clossing_number}
                    </TableCell>
                    <TableCell>
                        {new Date(clossing.clossing_date).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                        {clossing.counter?.name || 'N/A'}
                    </TableCell>
                    <TableCell>
                        <Chip
                        label={formatNumberWithComma(clossing.sales_total)+" "+"Sh"}
                        color="success"
                        variant="outlined"
                        size="small"
                        />
                    </TableCell>
                    <TableCell>
                        {formatNumberWithComma(clossing.expected_cash)} 
                    </TableCell>
                    <TableCell>
                        {formatNumberWithComma(clossing.actual_cash)}
                    </TableCell>
                    <TableCell>
                        <Chip
                        label={formatNumberWithComma(clossing.variance)}
                        color={clossing.variance >= 0 ? "success" : "error"}
                        variant="filled"
                        size="small"
                        />
                    </TableCell>
                    <TableCell>
                        <Chip
                        label={clossing.status.toUpperCase()}
                        color={getStatusColor(clossing.status)}
                        size="small"
                        />
                    </TableCell>
                    <TableCell align="center">
                        <IconButton
                        edge="end"
                        onClick={() => handleOpenView(clossing)}
                        color="primary"
                        size="small"
                        >
                        <Visibility />
                        </IconButton>
                        
                        {hasPermission(PERMISSIONS.EDIT) && (
                        <IconButton
                            edge="end"
                            onClick={() => handleOpenStatus(clossing)}
                            color="secondary"
                            size="small"
                        >
                        <Edit />
                        </IconButton>
                        )}
                        
                        {hasPermission(PERMISSIONS.DELETE) && clossing.status === 'draft' && (
                        <IconButton
                            edge="end"
                            onClick={() => handleOpenDelete(clossing)}
                            color="error"
                            size="small"
                        >
                            <Delete />
                        </IconButton>
                        )}
                    </TableCell>
                    </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        
        <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={pageState.pageData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
            }}
            sx={{ mt: 2 }}
        />
        </Paper>
    </motion.div>

    <Menu
        anchorEl={exportAnchorEl}
        open={Boolean(exportAnchorEl)}
        onClose={handleExportClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        >
        <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}>
            <TableChart fontSize="small" color="success" />
            Export to Excel (.xlsx)
        </MenuItem>
        <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}>
            <PictureAsPdf fontSize="small" color="error" />
            Export to PDF (.pdf)
        </MenuItem>
        <MenuItem onClick={handleExportDetailedPDF} sx={{ gap: 1 }}>
            <PictureAsPdf fontSize="small" color="info" />
            Export Detailed PDF
        </MenuItem>
        <MenuItem onClick={handleExportCSV} sx={{ gap: 1 }}>
            <TableChart fontSize="small" color="info" />
            Export to CSV (.csv)
        </MenuItem>
    </Menu>

    {/* New Day Clossing Dialog */}
    <Dialog
        open={openAdd}
        onClose={handleCloseAdd}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="lg"
    >
        <DialogTitle sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 'semibold' }}>
            New Day Clossing
        </Typography>
        </DialogTitle>
        <DialogContent dividers>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
            {steps.map((label) => (
            <Step key={label}>
                <StepLabel>{label}</StepLabel>
            </Step>
            ))}
        </Stepper>
        
        {activeStep === 0 && (
            <Box>
            <Typography variant="subtitle1" sx={{ mb: 3 }}>
                Select counter  to start day clossing
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel>Counter *</InputLabel>
                    <Select
                    value={selectedCounter}
                    onChange={(e) => setSelectedCounter(e.target.value)}
                    label="Counter *"
                    >
                    {pageState.counterNamesData.map((counter) => (
                        <MenuItem key={counter.id} value={counter.id}>
                            {counter.name}
                        </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                </Grid>
            </Grid>
            
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                variant="contained"
                onClick={handleCounterSelect}
                disabled={!selectedCounter || clossingLoading}
                startIcon={clossingLoading ? <CircularProgress size={20} /> : <Calculate />}
                >
                {clossingLoading ? 'Loading...' : 'Next'}
                </Button>
            </Box>
            </Box>
        )}
        
        {activeStep === 1 && (
            <Box>
            <Typography variant="subtitle1" sx={{ mb: 3 }}>
                Stock Items and Today's Sales
            </Typography>
            
            {todaySales && (
                <Alert severity="info" sx={{ mb: 3 }}>
                Today's Sales: {formatNumberWithComma(todaySales.total_sales || 0)} 
                ({todaySales.order_count || 0} orders)
                </Alert>
            )}
            
            <TableContainer>
                <Table size="small">
                <TableHead>
                    <TableRow
                        sx={{
                        backgroundColor: theme.palette.primary.main,
                        '& th': {
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '0.95rem'
                        }
                        }}>
                    <TableCell>Item Name</TableCell>
                    <TableCell align="right">Opening Qty</TableCell>
                    <TableCell align="right">Sold Qty</TableCell>
                    <TableCell align="right">Clossing Qty</TableCell>
                    <TableCell align="right">Opening Value</TableCell>
                    <TableCell align="right">Sales Value</TableCell>
                    <TableCell align="right">Clossing Value</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {counterStock.map((stock, index) => (
                    <TableRow key={index}>
                        <TableCell>{stock.name}</TableCell>
                        <TableCell align="right">
                        {formatNumberWithComma(stock.opening_quantity)} {stock.uom}
                        </TableCell>
                        <TableCell align="right">
                        <Chip
                            label={`${formatNumberWithComma(stock.sold_quantity)} ${stock.uom}`}
                            color="info"
                            size="small"
                        />
                        </TableCell>
                        <TableCell align="right">
                        <Chip
                            label={`${formatNumberWithComma(stock.clossing_quantity)} ${stock.uom}`}
                            color={stock.clossing_quantity > 0 ? "success" : "error"}
                            size="small"
                        />
                        </TableCell>
                        <TableCell align="right">
                        {formatNumberWithComma(stock.opening_value)}
                        </TableCell>
                        <TableCell align="right">
                        {formatNumberWithComma(stock.sales_value)}
                        </TableCell>
                        <TableCell align="right">
                        {formatNumberWithComma(stock.clossing_value)}
                        </TableCell>
                    </TableRow>
                    ))}
                    
                    <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
                    <TableCell colSpan={4} align="right">
                        <Typography sx={{ fontWeight: 'bold' }}>TOTALS:</Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {formatNumberWithComma(totals.opening)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {formatNumberWithComma(totals.sales)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {formatNumberWithComma(totals.clossing)}
                    </TableCell>
                    </TableRow>
                </TableBody>
                </Table>
            </TableContainer>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button
                variant="outlined"
                onClick={() => setActiveStep(0)}
                >
                Back
                </Button>
                <Button
                variant="contained"
                onClick={() => setActiveStep(2)}
                >
                Next
                </Button>
            </Box>
            </Box>
        )}
        
        {activeStep === 2 && (
            <Box>
            <Typography variant="subtitle1" sx={{ mb: 3 }}>
                Confirm and Save Day Clossing
            </Typography>
            
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Actual Cash Collected *"
                    type="number"
                    value={actualCash}
                    onChange={(e) => setActualCash(e.target.value)}
                    InputProps={{
                    startAdornment: <AttachMoney sx={{ mr: 1, color: 'text.secondary' }} />
                    }}
                />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Expected Cash (Calculated)"
                    type="number"
                    value={totals.expected}
                    InputProps={{
                    readOnly: true,
                    startAdornment: <AttachMoney sx={{ mr: 1, color: 'text.secondary' }} />
                    }}
                />
                </Grid>
                
                <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Notes"
                    value={clossingNotes}
                    onChange={(e) => setClossingNotes(e.target.value)}
                />
                </Grid>
            </Grid>
            
            <Card sx={{ mt: 3, p: 2, backgroundColor: theme.palette.background.default }}>
                <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body2">Opening Balance:</Typography>
                    <Typography variant="h6" color="primary">
                    {formatNumberWithComma(totals.opening)}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body2">Sales Total:</Typography>
                    <Typography variant="h6" color="success.main">
                    {formatNumberWithComma(totals.sales)}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body2">Clossing Balance:</Typography>
                    <Typography variant="h6" color="info.main">
                    {formatNumberWithComma(totals.clossing)}
                    </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">Expected Cash:</Typography>
                    <Typography variant="h6" color="warning.main">
                    {formatNumberWithComma(totals.expected)}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">Variance:</Typography>
                    <Typography variant="h6" color={variance >= 0 ? "success.main" : "error.main"}>
                    {formatNumberWithComma(variance)} 
                    {variance !== 0 && ` (${(variance/totals.expected*100).toFixed(2)}%)`}
                    </Typography>
                </Grid>
                </Grid>
            </Card>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button
                variant="outlined"
                onClick={() => setActiveStep(1)}
                >
                Back
                </Button>
                <Button
                variant="contained"
                color="success"
                onClick={handleSaveClossing}
                disabled={clossingLoading}
                startIcon={clossingLoading ? <CircularProgress size={20} /> : <Save />}
                >
                {clossingLoading ? 'Saving...' : 'Save Day Clossing'}
                </Button>
            </Box>
            </Box>
        )}
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCloseAdd} color="error">
            Cancel
        </Button>
        </DialogActions>
    </Dialog>
    
    {/* View Dialog */}
    <Dialog
        open={openView}
        onClose={handleCloseView}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="lg"
    >
        <DialogTitle sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 'semibold' }}>
            Day Clossing Details
        </Typography>
        </DialogTitle>
        <DialogContent dividers>
        {selectedRecord && (
            <Box>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Clossing Number:</b> {selectedRecord.clossing_number}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Date:</b> {new Date(selectedRecord.clossing_date).toLocaleDateString()}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Counter:</b> {selectedRecord.counter?.name || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Branch:</b> {selectedRecord.branch?.name || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Status:</b>
                    <Chip
                    label={selectedRecord.status.toUpperCase()}
                    color={getStatusColor(selectedRecord.status)}
                    size="small"
                    sx={{ ml: 1 }}
                    />
                </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2"><b>Prepared By:</b> {selectedRecord.user?.name || 'N/A'}</Typography>
                </Grid>
            </Grid>
            
            <Divider sx={{ my: 3 }} />
            
            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={3}>
                <Card elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">Opening Balance</Typography>
                    <Typography variant="h6" color="primary">
                    {formatNumberWithComma(selectedRecord.opening_balance)}
                    </Typography>
                </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                <Card elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">Sales Total</Typography>
                    <Typography variant="h6" color="success.main">
                    {formatNumberWithComma(selectedRecord.sales_total)}
                    </Typography>
                </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                <Card elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">Clossing Balance</Typography>
                    <Typography variant="h6" color="info.main">
                    {formatNumberWithComma(selectedRecord.clossing_balance)}
                    </Typography>
                </Card>
                </Grid>
                <Grid item xs={12} sm={3}>
                <Card elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">Variance</Typography>
                    <Typography variant="h6" color={selectedRecord.variance >= 0 ? "success.main" : "error.main"}>
                    {formatNumberWithComma(selectedRecord.variance)}
                    </Typography>
                </Card>
                </Grid>
            </Grid>
            
            {selectedRecord.items && selectedRecord.items.length > 0 && (
                <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography sx={{ fontWeight: 'medium' }}>Stock Items ({selectedRecord.items.length})</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer>
                    <Table size="small">
                        <TableHead>
                        <TableRow
                            sx={{
                            backgroundColor: theme.palette.primary.main,
                            '& th': {
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '0.95rem'
                            }
                            }}>
                            <TableCell>Item Name</TableCell>
                            <TableCell align="right">Opening Qty</TableCell>
                            <TableCell align="right">Sold Qty</TableCell>
                            <TableCell align="right">Clossing Qty</TableCell>
                            <TableCell align="right">Opening Value</TableCell>
                            <TableCell align="right">Sales Value</TableCell>
                            <TableCell align="right">Clossing Value</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {selectedRecord.items.map((item, index) => (
                            <TableRow key={index}>
                            <TableCell>{item.stock?.name || 'N/A'}</TableCell>
                            <TableCell align="right">{formatNumberWithComma(item.opening_quantity)}</TableCell>
                            <TableCell align="right">
                                <Chip
                                label={formatNumberWithComma(item.sold_quantity)}
                                color="info"
                                size="small"
                                />
                            </TableCell>
                            <TableCell align="right">
                                <Chip
                                label={formatNumberWithComma(item.clossing_quantity)}
                                color={item.clossing_quantity > 0 ? "success" : "error"}
                                size="small"
                                />
                            </TableCell>
                            <TableCell align="right">{formatNumberWithComma(item.opening_value)}</TableCell>
                            <TableCell align="right">{formatNumberWithComma(item.sales_value)}</TableCell>
                            <TableCell align="right">{formatNumberWithComma(item.clossing_value)}</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                </AccordionDetails>
                </Accordion>
            )}
            
            {selectedRecord.notes && (
                <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2"><b>Notes:</b></Typography>
                <Typography variant="body2" sx={{ p: 2, backgroundColor: theme.palette.background.default, borderRadius: 1 }}>
                    {selectedRecord.notes}
                </Typography>
                </Box>
            )}
            </Box>
        )}
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCloseView} color="error" variant="contained">
            Close
        </Button>
        </DialogActions>
    </Dialog>
    
    {/* Status Update Dialog */}
    <Dialog
        open={statusDialog}
        onClose={handleCloseStatus}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="sm"
    >
        <DialogTitle sx={{ textAlign: 'center' }}>
        Update Clossing Status
        </DialogTitle>
        <DialogContent>
        {selectedRecord && (
            <Box sx={{ mt: 2 }}>
            <Typography variant="body1" sx={{ mb: 3 }}>
                Update status for: <strong>{selectedRecord.clossing_number}</strong>
            </Typography>
            
            <Grid container spacing={2}>
                {['draft', 'submitted', 'approved', 'rejected'].map((status) => (
                <Grid item xs={6} key={status}>
                    <Button
                    fullWidth
                    variant={selectedRecord.status === status ? "contained" : "outlined"}
                    color={getStatusColor(status)}
                    onClick={() => handleUpdateStatus(status)}
                    sx={{ textTransform: 'capitalize' }}
                    >
                    {status}
                    </Button>
                </Grid>
                ))}
            </Grid>
            
            <TextField
                fullWidth
                multiline
                rows={3}
                label="Status Notes"
                value={clossingNotes}
                onChange={(e) => setClossingNotes(e.target.value)}
                sx={{ mt: 3 }}
            />
            </Box>
        )}
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCloseStatus} color="error">
            Cancel
        </Button>
        </DialogActions>
    </Dialog>
    
    {/* Delete Confirmation Dialog */}
    <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        TransitionComponent={Transition}
    >
        <DialogTitle sx={{ textAlign: 'center' }}>Delete Day Clossing</DialogTitle>
        <DialogContent>
        <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
            Are you sure you want to delete this day clossing?
        </Typography>
        {selectedRecord && (
            <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {selectedRecord.clossing_number}
            </Typography>
            <Typography variant="body2">
                Counter: {selectedRecord.counter?.name || 'N/A'}
            </Typography>
            <Alert severity="warning" sx={{ mt: 2 }}>
                This action cannot be undone. All clossing data will be permanently deleted.
            </Alert>
            </Box>
        )}
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCloseDelete} color="error" variant="contained">
            Cancel
        </Button>
        <Button onClick={handleDelete} color="primary" variant="contained">
            Confirm Delete
        </Button>
        </DialogActions>
    </Dialog>
    </Container>
);
};

export default DayClossing;

const Transition = React.forwardRef(function Transition(props, ref) {
return <Slide direction="up" ref={ref} {...props} />;
});

